import { useMutation } from '@tanstack/react-query';
import { createToken } from '../../api/setupServices';
import { useErrorContext } from '../../errorHandler/context/ErrorContext';
import { type ApiError, AppError } from '../../errorHandler/errors';

export type ICCTokenProps = {
  setToken: (token: string) => void;
  isSetup: boolean;
};

const useICCTokenMutation = ({ setToken, isSetup }: ICCTokenProps) => {
  const { emitError } = useErrorContext();

  return useMutation({
    mutationFn: async (integrationId: string) => {
      return createToken(
        {
          enterpriseId: integrationId,
          installationTokenExpirationInMinutes: 60,
        },
        isSetup,
      );
    },
    onSuccess: (clientCreateResponse) => {
      setToken(clientCreateResponse?.clientMetadata?.installationTokenValue);
    },
    onError: (e: ApiError) => {
      emitError(new AppError(e));
    },
  });
};

export default useICCTokenMutation;
